import {HomeLocationProps} from 'src/components/elements/descriptor/DescriptorType';
import Styles from '../../../Styles';
import LocationMarker from 'src/components/img/svg/LocationMarker';
import AVText from 'src/components/elements/AVText';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import NotificationIcon from 'src/components/img/svg/newui/notificationLogo';
import NotificationUnReadIcon from 'src/components/img/svg/newui/notificationUnReadLogo';
import Localized from 'src/constants/AppStrings';
import ShopIcon from 'src/components/img/svg/ShopIcon';
import QRCodeHeader from 'src/components/elements/home/QRCodeHeader';
import {RewardsWrappedComponent} from 'src/components/screens/home/RewardsHoc';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import MilkIcon from 'src/components/img/svg/newui/milk';
import CoolDrinkIcon from 'src/components/img/svg/newui/cooldrink';
import AwarenessIcon from 'src/components/img/svg/newui/awareness';
import FruitIcon from 'src/components/img/svg/newui/fruit';
import {Image, Platform, Pressable, StyleSheet, Text, View} from 'react-native';
import {
  quickAddOnsPointsTextStyleDescriptor,
  quickAddOnsProductImageContainerStyleDescriptor,
  quickAddOnsTextStyleDescriptor,
  quickAddOnsViewContainerStyleDescriptor,
} from '../../../elements/cart/descriptor/cart-elements-redesign';
import React from 'react';
import {RenderRecommendationsListProps} from './types';
import CanteenMenuItemBoilerPlate from '../../../img/svg/menuItemsBoilerplateIcons/CanteenMenuItemBoilerPlate';
import Util from '../../../../Util';
import AccountStore from '../../../../stores/AccountStore';

export function getCampusLocationStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusView: {
      flexDirection: 'row',
      maxWidth: '80%',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      marginLeft: Styles.Spacing.m3,
      marginRight: Styles.Spacing.m4,
      minHeight: Styles.MinTouchableArea,
      marginBottom: 20,
    },
    linkLocationBtnStyle: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      color: Styles.Colors.Canteen.primary,
    },
    linkView: {
      alignSelf: 'flex-start',
      borderBottomColor: Styles.Colors.Canteen.primary,
      borderBottomWidth: 1.5,
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.robotoRegular,
    },
  };
}

export function getScanProductName(): string {
  return Localized.Labels.scan_product;
}

export function getScanProductBtnStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    applyButtonText: {
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: Styles.Fonts.f7,
      textAlign: 'right',
      fontWeight: '400',
    },
  };
}
export function backGroundColorHomeScreen(): string {
  return Styles.white;
}
export function locationListIcon(): JSX.Element {
  return <ShopIcon size={Styles.Spacing.m4} />;
}
export function locationHeaderName(): string {
  return Localized.Labels.locations;
}

export function recommendationsBlockRenderItem({
  item,
  index,
  isFirstItem,
  isLastItem,
  onMenuItemPress,
}: RenderRecommendationsListProps): JSX.Element {
  return (
    <Pressable
      role="button"
      onPress={() => onMenuItemPress(item)}
      key={index}
      accessibilityRole="button"
      style={{
        ...(Platform.OS === 'web' ? {} : styles.shadow),
      }}
    >
      <View
        accessible
        style={[
          quickAddOnsViewContainerStyleDescriptor(),
          isFirstItem && styles.firstItem,
          isLastItem && styles.lastItem,
        ]}
      >
        <View>
          {/*<Pressable*/}
          {/*  style={quickAddOnsProductPlusIconStyleDescriptor()}*/}
          {/*  onPress={() => onMenuItemPress(item, true)}*/}
          {/*  hitSlop={Styles.HitSlop_4}*/}
          {/*>*/}
          {/*<PlusSignIcon />*/}
          {/*</Pressable>*/}
          {item.imageUrl ? (
            <Image
              accessible={true}
              accessibilityLabel="Product image"
              accessibilityRole="image"
              aria-label="Product image"
              role="img"
              style={quickAddOnsProductImageContainerStyleDescriptor()}
              source={{uri: item.imageUrl}}
              resizeMode={'cover'}
            />
          ) : (
            getPlaceholderImage()
          )}
        </View>
        <Text
          style={[quickAddOnsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product name"
          accessibilityLabel={`${item.productName} product name`}
          aria-label={`${item.productName} product name`}
        >
          {item?.productName}
        </Text>
        <Text
          style={[quickAddOnsPointsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product price"
          accessibilityLabel={`${item.productName} product price`}
          aria-label={`${item.productName} product price`}
        >
          {Util.formatCurrency(null, +item.price, AccountStore.getCurrency())}
        </Text>
      </View>
    </Pressable>
  );
}

export function getPlaceholderImage() {
  return <CanteenMenuItemBoilerPlate />;
}
export function getLocationEmptyIcons() {
  return {
    milk: <MilkIcon fill={getLayoutDescriber().primaryColor()} />,
    coolDrink: <CoolDrinkIcon fill={getLayoutDescriber().primaryColor()} />,
    awareness: <AwarenessIcon fill={getLayoutDescriber().primaryColor()} />,
    fruit: <FruitIcon fill={getLayoutDescriber().primaryColor()} />,
  };
}
export function greetingBalanceRewardsView(
  shortcutBar: JSX.Element,
  _data?: {
    [index: string]: {[index: string]: number | string};
  },
  location?: string,
  trackerSlot?: JSX.Element,
): JSX.Element {
  return (
    <>
      <QRCodeHeader isConnected={true} />
      {shortcutBar}
      {trackerSlot}
      {location && <RewardsWrappedComponent data={_data} />}
    </>
  );
}

export function linkLocationDropDown(props?: HomeLocationProps): JSX.Element {
  return (
    <>
      <LocationMarker
        size={Styles.Fonts.f3}
        color={Styles.Colors.Canteen.lightGreen}
      />
      <AVText
        style={[homeLocationHeaderStyleDescriptor().campusNameText]}
        numberOfLines={1}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      >
        {props.locationNameText}
      </AVText>
      <FontAwesome5Pro
        accessible={true}
        accessibilityLabel={
          'Down arrow icon, Double tap to the Locations Screen'
        }
        aria-label={'Down arrow icon, Double tap to the Locations Screen'}
        name="chevron-down"
        color={Styles.lightGray}
        size={Styles.Heights.touchTargetHeight0}
        style={[homeLocationHeaderStyleDescriptor().campusArrow]}
        testID="qa_dpd_SelectLocation"
      />
    </>
  );
}

export function readUnreadNotificationIcon(
  props?: HomeLocationProps,
): JSX.Element {
  return (
    <>
      {props.readOrUnreadNotificaton ? (
        <NotificationUnReadIcon
          color={Styles.Colors.Canteen.lightGreen}
          size={Styles.Fonts.f4 + 6}
        />
      ) : (
        <NotificationIcon
          color={Styles.Colors.Canteen.lightGreen}
          size={Styles.Fonts.f3}
        />
      )}
    </>
  );
}

export function homeLocationHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusNameText: {
      marginLeft: Styles.Spacing.m0,
      fontSize: Styles.Fonts.f7,
      fontWeight: '700',
      maxWidth: '100%',
      flexShrink: 1,
      color: Styles.Colors.Canteen.lightGreen,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    campusArrow: {
      marginLeft: Styles.Spacing.m2,
      marginTop: 2,
      color: Styles.Colors.Canteen.lightGreen,
    },
  };
}

export function shortCutButtonBorderColor(): string {
  return Styles.Colors.PayNew.brightGray;
}

const styles = StyleSheet.create({
  firstItem: {
    marginLeft: Styles.Spacing.m3,
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: {width: 2, height: 4},
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
    marginBottom: Styles.Spacing.m1,
    minHeight: Styles.MinTouchableArea,
  },
  lastItem: {
    marginRight: Styles.Spacing.m3,
  },
  font: {
    fontFamily: Styles.FontFamily.gothamRegular,
    color: Styles.Colors.PayNew.black01,
  },
  quickAdd: {
    backgroundColor: Styles.Colors.Aramark.black01,
    alignItems: 'center',
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    alignSelf: 'center',
    width: 110,
    height: 110,
  },
});

export default {
  getScanProductName,
  getScanProductBtnStyle,
  getCampusLocationStyles,
  backGroundColorHomeScreen,
  homeLocationHeaderStyleDescriptor,
  linkLocationDropDown,
  readUnreadNotificationIcon,
  locationHeaderName,
  greetingBalanceRewardsView,
  getLocationEmptyIcons,
  locationListIcon,
  getTrackerPlacement: () => 'belowQrTile',
  shortCutButtonBorderColor,
  recommendationsBlockRenderItem,
  getPlaceholderImage,
};
